/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Tabs } from 'antd-mobile'
import * as Utils from '@utils/utils'
import { convertMatchCountText } from '@utils/utils'
import { LS_SPORTS_TYPE, PAGE_TYPE, SPORTS_TYPE } from '@interface/common'
import useRootStore from '@store/useRootStore'
import { Models } from 'rmc-tabs/lib/Models'
import { GAME_TYPE, MAJOR_SPORT_IDS } from '@game-type/game-market-types'
import { useEffect, useRef } from 'react'
import { observer } from 'mobx-react'
import * as _ from 'lodash'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { Schema$UserPickMatchCountPerSports } from '@interface/user-pick'
import StorageUtils from '@utils/storage-utils'
import { SportsIco } from '@styles/match.style'
import { LS_SPORT_ID_ICON_MAP, SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
import { SPORT_ID_GRAY_ICON_MAP } from '@shared/SportIdGroup/Gray'
import EtcAllTabImg from '@assets/images/icon/matchup_icon/etc-all-tab.png'
import EtcAllTabActiveImg from '@assets/images/icon/matchup_icon/etc-all-tab-active.png'
import HotActiveImg from '@assets/images/btn/hot-tab-btn.gif'
import { Schema$MatchupMetaSport } from '@interface/matchup'
import { DefaultTabBar } from 'antd-mobile/lib/tabs'
import { isMobile } from 'react-device-detect'
import HotTxtIcon from '@shared/Icon/TxtIcon/HotTxtIcon'

function getHotMatchTabList(count?: string | number): Models.TabData {
  return {
    title: (
      <div className="tab-item hot-tab">
        <SportsIco css={{ marginRight: '6px;' }} className="sports-ico hot-ico">
          <span className="default-ico"><HotTxtIcon/></span>
          <span className="active-ico"><HotTxtIcon/><img src={HotActiveImg} alt="HOT 활성화"/></span>
        </SportsIco>
        <span className="txt">인기</span>
        <span className="num">{count}</span>
      </div>
    ),
    name: '인기',
    key: SPORTS_TYPE.HOT,
    sportId: SPORTS_TYPE.HOT,
  }
}

function getAllSportsTabList(count?: string | number): Models.TabData {
  return {
    title: (
      <div className="tab-item">
        <SportsIco css={{ marginRight: '6px;' }} className="sports-ico all-ico">
          <span className="default-ico"><img src={EtcAllTabImg} alt="전체"/></span>
          <span className="active-ico"><img src={EtcAllTabActiveImg} alt="전체 활성화"/></span>
        </SportsIco>
        <span className="txt">전체</span>
        <span className="num">{convertMatchCountText(count)}</span>
      </div>
    ),
    name: '전체',
    key: SPORTS_TYPE.TODAY,
    sportId: SPORTS_TYPE.TODAY,
  }
}

function getOnlySportsAndResultTabList(
  pageType: PAGE_TYPE, sportTabSports: Schema$MatchupMetaSport[], showOnlyExistsItem = true): Models.TabData[] {
  const items = []
  if (pageType === PAGE_TYPE.MATCHUP || pageType === PAGE_TYPE.MATCHUP_RESULT) {
    _.forEach(sportTabSports, sport => {
      if (showOnlyExistsItem && sport.matchCount < 1) {
        return true
      }

      items.push(makeSportTabItemBySportId(sport.UniqueID, sport.name, convertMatchCountText(sport.matchCount)))
    })
  }
  return items
}

function getMajorSportsTabList(
  pageType: PAGE_TYPE,
  userPickMatchCountPerSports: Schema$UserPickMatchCountPerSports,
  showOnlyExistsItem = false,
): Models.TabData[] {
  const soccerCount = userPickMatchCountPerSports?.[SPORTS_TYPE.SOCCER] ?? 0
  const basketballCount = userPickMatchCountPerSports?.[SPORTS_TYPE.BASKETBALL] ?? 0
  const baseballCount = userPickMatchCountPerSports?.[SPORTS_TYPE.BASEBALL] ?? 0
  const volleyCount = userPickMatchCountPerSports?.[SPORTS_TYPE.VOLLEYBALL] ?? 0
  const iceHockeyCount = userPickMatchCountPerSports?.[SPORTS_TYPE.ICE_HOCKEY] ?? 0

  const items = [
    {
      title: <div className="tab-item sports">
        <SportsIco className="sports-ico">
          <span
            className="default-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SPORTS_TYPE.SOCCER] : SPORT_ID_GRAY_ICON_MAP[SPORTS_TYPE.SOCCER]}</span>
          <span
            className="active-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SPORTS_TYPE.SOCCER] : SPORT_ID_ICON_MAP[SPORTS_TYPE.SOCCER]}</span>
        </SportsIco>
        <span className="txt">축구</span>
        <span className="num">{convertMatchCountText(soccerCount)}</span>
      </div>,
      name: '축구',
      key: SPORTS_TYPE.SOCCER,
      sportId: SPORTS_TYPE.SOCCER,
    },
    {
      title: <div className="tab-item sports">
        <SportsIco className="sports-ico">
          <span
            className="default-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SPORTS_TYPE.BASKETBALL] : SPORT_ID_GRAY_ICON_MAP[SPORTS_TYPE.BASKETBALL]}</span>
          <span
            className="active-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SPORTS_TYPE.BASKETBALL] : SPORT_ID_ICON_MAP[SPORTS_TYPE.BASKETBALL]}</span>
        </SportsIco>
        <span className="txt">농구</span>
        <span className="num">{convertMatchCountText(basketballCount)}</span>
      </div>,
      name: '농구',
      key: SPORTS_TYPE.BASKETBALL,
      sportId: SPORTS_TYPE.BASKETBALL,
    },
    {
      title: <div className="tab-item sports">
        <SportsIco className="sports-ico">
          <span
            className="default-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SPORTS_TYPE.BASEBALL] : SPORT_ID_GRAY_ICON_MAP[SPORTS_TYPE.BASEBALL]}</span>
          <span
            className="active-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SPORTS_TYPE.BASEBALL] : SPORT_ID_ICON_MAP[SPORTS_TYPE.BASEBALL]}</span>
        </SportsIco>
        <span className="txt">야구</span>
        <span className="num">{convertMatchCountText(baseballCount)}</span>
      </div>,
      name: '야구',
      key: SPORTS_TYPE.BASEBALL,
      sportId: SPORTS_TYPE.BASEBALL,
    },
    {
      title: <div className="tab-item sports">
        <SportsIco className="sports-ico">
          <span
            className="default-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SPORTS_TYPE.VOLLEYBALL] : SPORT_ID_GRAY_ICON_MAP[SPORTS_TYPE.VOLLEYBALL]}</span>
          <span
            className="active-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SPORTS_TYPE.VOLLEYBALL] : SPORT_ID_ICON_MAP[SPORTS_TYPE.VOLLEYBALL]}</span>
        </SportsIco>
        <span className="txt">배구</span>
        <span className="num">{convertMatchCountText(volleyCount)}</span>
      </div>,
      name: '배구',
      key: SPORTS_TYPE.VOLLEYBALL,
      sportId: SPORTS_TYPE.VOLLEYBALL,
    },
    {
      title: <div className="tab-item sports ice-hockey">
        <SportsIco className="sports-ico">
          <span
            className="default-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SPORTS_TYPE.ICE_HOCKEY] : SPORT_ID_GRAY_ICON_MAP[SPORTS_TYPE.ICE_HOCKEY]}</span>
          <span
            className="active-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[SPORTS_TYPE.ICE_HOCKEY] : SPORT_ID_ICON_MAP[SPORTS_TYPE.ICE_HOCKEY]}</span>
        </SportsIco>
        <span className="txt ice-hockey">아이스하키</span>
        <span className="num">{convertMatchCountText(iceHockeyCount)}</span>
      </div>,
      name: '아이스하키',
      key: SPORTS_TYPE.ICE_HOCKEY,
      sportId: SPORTS_TYPE.ICE_HOCKEY,
    },
  ]

  if (pageType === PAGE_TYPE.USER_PICK_HOME && showOnlyExistsItem) {
    _.remove(items, item => {
      switch (item.key) {
        case SPORTS_TYPE.SOCCER:
          return soccerCount === 0
        case SPORTS_TYPE.BASKETBALL:
          return basketballCount === 0
        case SPORTS_TYPE.BASEBALL:
          return baseballCount === 0
        case SPORTS_TYPE.VOLLEYBALL:
          return volleyCount === 0
        case SPORTS_TYPE.ICE_HOCKEY:
          return iceHockeyCount === 0
        default:
          return false
      }
    })
  }

  return items
}

function makeSportTabItemBySportId(sportIdParam: number, sportName: string, count: string)
  : { title: JSX.Element; name: string; key: SPORTS_TYPE; sportId: SPORTS_TYPE } {
  const sportId = _.toString(sportIdParam) as SPORTS_TYPE
  return {
    title: <div className="tab-item sports">
      <SportsIco className="sports-ico">
          <span
            className="default-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[sportId] : SPORT_ID_GRAY_ICON_MAP[sportId]}</span>
        <span
          className="active-ico">{Utils.isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[sportId] : SPORT_ID_ICON_MAP[sportId]}</span>
      </SportsIco>
      <span className="txt">{sportName}</span>
      <span className="num">{convertMatchCountText(count)}</span>
    </div>,
    name: sportName,
    key: sportId,
    sportId: sportId,
  }
}

function getLsMajorSportsTabList(): Models.TabData[] {
  return [
    {
      title: <span className="tab-item">
        <span className="txt">축구</span>
      </span>,
      name: '축구',
      key: LS_SPORTS_TYPE.SOCCER,
      sportId: LS_SPORTS_TYPE.SOCCER,
    },
    {
      title: <span className="tab-item">
        <span className="txt">농구</span>
      </span>,
      name: '농구',
      key: LS_SPORTS_TYPE.BASKETBALL,
      sportId: LS_SPORTS_TYPE.BASKETBALL,
    },
    {
      title: <span className="tab-item">
        <span className="txt">야구</span>
      </span>,
      name: '야구',
      key: LS_SPORTS_TYPE.BASEBALL,
      sportId: LS_SPORTS_TYPE.BASEBALL,
    },
    {
      title: <span className="tab-item">배구</span>,
      name: '배구',
      key: LS_SPORTS_TYPE.VOLLEYBALL,
      sportId: LS_SPORTS_TYPE.VOLLEYBALL,
    },
    {
      title: <span className="sports ice-hockey tab-item">아이스하키</span>,
      name: '아이스하키',
      key: LS_SPORTS_TYPE.ICE_HOCKEY,
      sportId: LS_SPORTS_TYPE.ICE_HOCKEY,
    },
  ]
}

function getEtcTabList(
  pageType?: PAGE_TYPE,
  userPickCountPerSports?: Schema$UserPickMatchCountPerSports,
  showOnlyExistsItem = false,
): Models.TabData {
  let total = 0
  let major = 0
  for (const key in userPickCountPerSports) {
    if (key === 'total') {
      total += userPickCountPerSports[key]
    } else if (MAJOR_SPORT_IDS.includes(Number(key))) {
      major += userPickCountPerSports[key]
    }
  }
  const count = total - major
  if (pageType === PAGE_TYPE.USER_PICK_HOME && showOnlyExistsItem && count === 0) {
    return {} as Models.TabData
  }
  return {
    title: <span className="tab-item">
      <span className="txt">기타</span>
      <span className="num">{count}</span>
    </span>,
    name: '기타',
    key: SPORTS_TYPE.ETC,
    sportId: SPORTS_TYPE.ETC,
  }
}

function getAllMatchCount(sportTabSports: Schema$MatchupMetaSport[]) {
  if (!_.isNil(sportTabSports) && _.isEmpty(sportTabSports)) {
    return 0
  }

  let totalCount: number
  _.forEach(sportTabSports, sport => {
    if (_.isNil(totalCount)) {
      totalCount = 0
    }
    totalCount += sport.matchCount
  })
  return totalCount
}

function getSportsTabList(
  pageType: PAGE_TYPE,
  sportTabSports: Schema$MatchupMetaSport[],
  userPickCountPerSports?: Schema$UserPickMatchCountPerSports,
  showOnlyExistsItem = false,
  hotMatchCount?: number,
): Models.TabData[] {

  let allSportCount: number
  if (pageType === PAGE_TYPE.MATCHUP) {
    allSportCount = getAllMatchCount(sportTabSports)
  } else {
    allSportCount = userPickCountPerSports?.total ?? 0
  }

  let tabList: Models.TabData[] = []
  if (pageType === PAGE_TYPE.MATCHUP || pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.LIVE) {
    tabList.push(getHotMatchTabList(hotMatchCount))
  }
  tabList.push(getAllSportsTabList(allSportCount))

  if (Utils.isLsportsEnv()) {
    tabList = tabList.concat(getLsMajorSportsTabList())
  } else {
    if (pageType === PAGE_TYPE.USER_PICK_HOME || pageType === PAGE_TYPE.USER_PICK) {
      tabList = tabList.concat(getMajorSportsTabList(pageType, userPickCountPerSports, showOnlyExistsItem))
    } else {
      tabList = tabList.concat(getOnlySportsAndResultTabList(pageType, sportTabSports))
    }
  }

  if (pageType !== PAGE_TYPE.MATCHUP && pageType !== PAGE_TYPE.MATCHUP_RESULT) {
    const etcTabList = getEtcTabList(pageType, userPickCountPerSports, showOnlyExistsItem)
    if (!_.isEmpty(etcTabList)) {
      tabList = tabList.concat([etcTabList])
    }
  }
  return tabList
}

function getLiveSportsTabList(
  pageType: PAGE_TYPE, sportTabSports: Schema$MatchupMetaSport[], hotMatchCount: number
): Models.TabData[] {
  const allSportCount = getAllMatchCount(sportTabSports)
  let tabList: Models.TabData[] = [getHotMatchTabList(hotMatchCount), getAllSportsTabList(allSportCount)]
  if (Utils.isLsportsEnv()) {
    tabList = tabList.concat(getLsMajorSportsTabList())
  } else {
    tabList = tabList.concat(getOnlySportsAndResultTabList(pageType, sportTabSports, false))

  }
  return tabList
}

function getResultPageSportsTabList(
  pageType: PAGE_TYPE, sportTabSports: Schema$MatchupMetaSport[], hotMatchCount: number
): Models.TabData[] {
  const allSportCount = getAllMatchCount(sportTabSports)
  let tabList: Models.TabData[] = [getHotMatchTabList(hotMatchCount), getAllSportsTabList(allSportCount)]
  if (Utils.isLsportsEnv()) {
    tabList = tabList.concat(getLsMajorSportsTabList())
  } else {
    tabList = tabList.concat(
      getOnlySportsAndResultTabList(pageType, sportTabSports))
  }
  // tabList = tabList.concat([getEtcTabList()])
  return tabList
}

interface SportTabProps {
  pageType: PAGE_TYPE
  tabColor?: string
  className?: string
  showOnlyExistsItem?: boolean
}

export const SportTab = observer((props: SportTabProps) => {
  const { matchupStore, authStore, userPickStore, globalStore, componentStore, logStore } = useRootStore()
  const {
    sportTab,
    currentGameKey,
    matchTabInitializeSportId,
    sportTabSports,
    hotMatchCount,
  } = matchupStore
  const { currentSportTab, isMatchPackageLoading, userPickHomeMatchCountPerSports } = userPickStore
  const { isGoToFirstScrollOfSportTab } = componentStore
  const { pageType, tabColor, className, showOnlyExistsItem = false } = props

  const matchupEtcFilterAlertOptions = globalStore.getMatchupEtcFilterAlertOptions()
  const selectedSportTab = pageType === PAGE_TYPE.USER_PICK_HOME ? currentSportTab : sportTab

  const isResultPage = pageType === PAGE_TYPE.MATCHUP_RESULT

  let subTabList = []
  if (isResultPage) {
    subTabList = getResultPageSportsTabList(pageType, sportTabSports, hotMatchCount)
  } else if (currentGameKey === GAME_TYPE.LIVE) {
    subTabList = getLiveSportsTabList(pageType, sportTabSports, hotMatchCount)
  } else {
    subTabList = getSportsTabList(
      pageType, sportTabSports, userPickHomeMatchCountPerSports, showOnlyExistsItem, hotMatchCount,
    )
  }

  let customTabColor: string
  if (tabColor) {
    customTabColor = tabColor
  } else {
    customTabColor = '#1c202b'
  }

  function getSportsSubKey(sport: number) {
    return subTabList[sport].key
  }

  function getSportId(sport: number) {
    return subTabList[sport].sportId
  }

  function getSportName(sport: number) {
    return subTabList[sport].name
  }

  function initializeState(isUnMount: boolean): void {
    if (isUnMount) {
      const subKey = SPORTS_TYPE.HOT
      const sportId = SPORTS_TYPE.HOT

      if (pageType === PAGE_TYPE.USER_PICK_HOME) {
        userPickStore.setSportTab(0, subKey, Number(sportId))
      } else {
        matchupStore.setSportTab(0, subKey, Number(sportId))
      }
    } else if (isResultPage) {
      matchupStore.setSportTab(0, SPORTS_TYPE.HOT, Number(SPORTS_TYPE.HOT))
    } else if (pageType === PAGE_TYPE.USER_PICK && !_.isNil(matchTabInitializeSportId)) {
      const tabIndex = _.findIndex(subTabList, { sportId: _.toString(matchTabInitializeSportId) })
      matchupStore.setSportTab(
        _.toNumber(tabIndex > -1 ? tabIndex : 0),
        _.toString(matchTabInitializeSportId),
        _.toNumber(matchTabInitializeSportId),
      )
    } else if (pageType === PAGE_TYPE.USER_PICK_HOME) {
      if (_.isNil(matchTabInitializeSportId)) {
        userPickStore.setSportTab(0, SPORTS_TYPE.TODAY, Number(SPORTS_TYPE.TODAY))
      }
    } else if (!_.isNil(matchTabInitializeSportId)) {
      const tabIndex = _.findIndex(subTabList, { sportId: _.toString(matchTabInitializeSportId) })
      matchupStore.setSportTab(
        _.toNumber(tabIndex > -1 ? tabIndex : 0),
        _.toString(matchTabInitializeSportId),
        _.toNumber(matchTabInitializeSportId),
      )
    } else {
      if (matchupStore.currentGameKey === GAME_TYPE.LIVE) {
        matchupStore.setSportTab(1, SPORTS_TYPE.TODAY, Number(SPORTS_TYPE.TODAY))
      } else {
        matchupStore.setSportTab(0, SPORTS_TYPE.HOT, Number(SPORTS_TYPE.HOT))
      }
    }
  }

  useOnMount(() => {
    if (pageType === PAGE_TYPE.USER_PICK_HOME) {
      matchupStore.setCurrentGameKey(GAME_TYPE.CROSS)
    }
    initializeState(false)
  })

  useEffect(() => {
    if (!_.isNil(matchTabInitializeSportId)) {
      const tabIndex = _.findIndex(subTabList, { sportId: _.toString(matchTabInitializeSportId) })
      matchupStore.setSportTab(
        _.toNumber(tabIndex > -1 ? tabIndex : 0),
        _.toString(matchTabInitializeSportId),
        _.toNumber(matchTabInitializeSportId),
      )
    }
  }, [matchTabInitializeSportId])

  useOnUnmount(() => {
    initializeState(true)
  })

  const defaultTabBarRefs = useRef<DefaultTabBar>(null)
  useEffect(() => {
    if (isGoToFirstScrollOfSportTab) {
      if (isMobile) {
        defaultTabBarRefs.current.layout.scrollLeft = 0
      } else {
        defaultTabBarRefs.current.layout.parentNode['scrollLeft'] = 0
      }
      componentStore.setIsGoToFirstScrollOfSportTab(false)
    }
  }, [isGoToFirstScrollOfSportTab])

  const onTabSportClick = (event) => {
    if(pageType === PAGE_TYPE.USER_PICK && isMatchPackageLoading) {
      event.stopPropagation()
    }
  }

  const onTabSportChange = (td: Models.TabData, idx: number) => {
    if (pageType === PAGE_TYPE.USER_PICK ) {
      const sportName = getSportName(idx)
      logStore.writeButtonLog({ pageId: 'a040', buttonId: '003', buttonDetails: sportName }).catch(console.error)
    }
    const subKey = getSportsSubKey(idx)
    const sportId = getSportId(idx)

    if (pageType === PAGE_TYPE.USER_PICK_HOME) {
      userPickStore.setSportTab(idx, subKey, Number(sportId))
    } else {
      matchupStore.setSportTab(idx, subKey, Number(sportId))
      componentStore.setIsGoToScrollTopOfMatchList(true)
    }
    authStore.checkAdultAuthentication().catch(console.error)

    if (currentGameKey === GAME_TYPE.CROSS) { // 스포츠 탭
      if (sportId === SPORTS_TYPE.ETC) {  // 기타 탭
        if (pageType !== PAGE_TYPE.USER_PICK
          && pageType !== PAGE_TYPE.USER_PICK_HOME
          && pageType !== PAGE_TYPE.MATCHUP_RESULT) {  // 홈 화면 컨텐츠, 경기 결과의 기타 탭이 아닐 때
          if (matchupEtcFilterAlertOptions.enabled) {
            StorageUtils.saveMatchEtcFilterAlertUpdatedTime(matchupEtcFilterAlertOptions.updatedAt)
          }
          componentStore.updateIsVisibleEtcAlertOptions()
        }
      }
    }

    if (pageType === PAGE_TYPE.USER_PICK || pageType === PAGE_TYPE.USER_PICK_HOME) {
      matchupStore.setMatchTabInitializeSportId(undefined)
      matchupStore.setMatchTabInitializeMajorUniqueId(undefined)
    }
  }

  let TabClassName = ''
  if (className) {
    TabClassName = className
  }

  return (
    <Tabs
      tabs={subTabList}
      page={selectedSportTab}
      prefixCls={`${TabClassName} am-tabs`}
      tabBarBackgroundColor={customTabColor}
      onChange={onTabSportChange}
      onTabClick={onTabSportClick}
      renderTabBar={tabProps => {
        return <Tabs.DefaultTabBar {...tabProps} ref={defaultTabBarRefs} page={subTabList.length}/>
      }}
    />
  )
})
